import React, { useEffect, useState, useContext, createContext, useReducer } from "react";
import Adjudication from '../Authorizations/Adjudication';

export const Authorizations = (props) => {
    return (<Adjudication eventNumber={props.location?.state?.eventNumber} rfsData={props.location?.state?.rfsData} claimId={props.location?.state?.claimId} clientId={props.location?.state?.clientId} eventId={props.location?.state?.eventId} preauthorizedAmount={props.location?.state?.preauthorizedAmount} />
    );
};